<template>
  <div class="header-wrapper">
    <!-- 移动端汉堡菜单按钮 -->
    <div v-if="isMobile" class="menu-btn" @click="$emit('toggleDrawer')">
      <i class="el-icon-s-fold"></i>
    </div>
    
    <div class="header-title">
      <span class="mobile-hidden">计算器</span>
      <span class="pc-hidden">菜单</span>
    </div>
    <div class="header-right">
      <el-dropdown>
        <span class="el-dropdown-link">
           {{ user.nickName }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="$router.push('/person')">个人信息</el-dropdown-item>
            <el-dropdown-item @click="$router.push('/password')">修改密码</el-dropdown-item>
            <el-dropdown-item @click="$router.push('/login')">退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ['user', 'isMobile'],
  emits: ['toggleDrawer'],
  data() {
    return {

    }
  },
  created() {
  }
}
</script>

<style scoped>
.header-wrapper {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ccc;
  display: flex;
}

.menu-btn {
  width: 50px;
  text-align: center;
  cursor: pointer;
}

.menu-btn i {
  font-size: 20px;
}

.header-title {
  padding-left: 30px;
  font-weight: bold;
  color: dodgerblue;
}

.header-right {
  flex: 1;
  text-align: right;
  padding-right: 20px;
}

/* 移动端暗色模式 */
@media screen and (max-width: 768px) {
  .header-wrapper {
    background-color: #1a1a1a;
    border-bottom-color: #3a3a3a;
  }
  
  .menu-btn {
    color: #e6a23c;
  }
  
  .header-title {
    color: #e6a23c;
    padding-left: 10px;
  }
  
  .header-right .el-dropdown-link {
    color: #e6a23c;
  }
}
</style>
